


















































































































































































































































import Vue from 'vue';
import ExtraMobileMenu from '@/components/menu/ExtraMobileMenu.vue';
import { EAccountTypes, TCollectionInteractiveIcons, userRoles } from '@/types';
import truffleInteractiveIcons from '@/utils/truffleInteractiveIcons';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'MobileMenu',
  components: { ExtraMobileMenu },

  mounted() {
    this.prevScrollPos = window.pageYOffset;
    this.addEventMatchMedia();
    this.currentAccountType = this.accountType;
  },

  watch: {
    accountType(newValue) {
      if (newValue) {
        this.currentAccountType = newValue;
      }
    },
  },

  computed: {
    ...mapGetters({
      getUser: 'getUser',
      userCan: 'userCan',
      getRoles: 'getRoles',
    }),
    checkRolesForToggle(): boolean {
      if (
        this.userCan(this.roles.MANAGER) &&
        this.userCan(this.roles.PUBLISHER)
      ) {
        return true;
      }

      return false;
    },
    campaignAction(): boolean {
      return this.$route.meta?.group === 'campaign';
    },
    audienceAction(): boolean {
      return this.$route.meta?.group === 'audience';
    },
    moderationAction(): boolean {
      return this.$route.meta?.group === 'moderation';
    },
    analiticsAction(): boolean {
      return this.$route.meta?.group === 'analitics';
    },
    reportBuilderActive(): boolean {
      return this.$route.name === 'ReportBuilder';
    },
    existReportsActive(): boolean {
      return this.$route.name === 'ExistReports';
    },
    extraMenuAction(): boolean {
      return (
        this.extraShow ||
        this.campaignAction ||
        this.moderationAction ||
        this.audienceAction
      );
    },
    truffleInteractiveIcons(): TCollectionInteractiveIcons {
      return truffleInteractiveIcons;
    },
    accountType(): string {
      return this.$route.meta?.accountType;
    },
    isAccountTypeAdvertiser(): boolean {
      return this.currentAccountType === EAccountTypes.ADVERTISER;
    },
    isAccountTypePublisher(): boolean {
      return this.currentAccountType === EAccountTypes.PUBLISHER;
    },
  },

  methods: {
    goToRoute(link) {
      this.closeExtraMenu();

      if (this.$route.path !== link) {
        this.$router.push(link);
      }
    },
    toggleExtraMenu(show) {
      if (show === 'analiticsShow') {
        this.extraShow = false;
        this.analiticsShow = !this.analiticsShow;
      } else if (show === 'extraShow') {
        this.analiticsShow = false;
        this.extraShow = !this.extraShow;
      }
    },
    toggleAdvertiserPublisherMenu() {
      if (this.isAccountTypeAdvertiser) {
        this.goToRoute('/publisher/inventory');
      } else if (this.isAccountTypePublisher) {
        this.goToRoute('/dashboard');
      }
    },
    openExtraMenu() {
      this.extraShow = true;
    },
    closeExtraMenu() {
      this.analiticsShow = false;
      this.extraShow = false;
    },
    addEventMatchMedia() {
      this.matchMedia = window.matchMedia('(max-width: 769px)');
      this.checkMatchMedia();
      this.matchMedia.addEventListener('change', this.checkMatchMedia);
    },

    checkMatchMedia() {
      if (!this.matchMedia) return;

      if (this.matchMedia.matches) {
        this.addEventScrollMenu();
      } else {
        this.removeEventScrollMenu();
      }
    },

    addEventScrollMenu() {
      window.addEventListener('scroll', this.checkScroll);
    },

    removeEventScrollMenu() {
      window.removeEventListener('scroll', this.checkScroll);
    },

    checkScroll() {
      this.currentScrollPos = window.pageYOffset;
      if (this.prevScrollPos < this.currentScrollPos) {
        this.show = false;
      } else {
        this.show = true;
      }
      this.prevScrollPos = this.currentScrollPos;
    },
  },

  data() {
    return {
      show: true,
      extraShow: false,
      analiticsShow: false,
      matchMedia: null as MediaQueryList | null,
      prevScrollPos: 0 as number,
      currentScrollPos: 0 as number,
      currentAccountType: EAccountTypes.ADVERTISER as string,
      roles: {
        ADMIN: userRoles.ADMIN,
        MANAGER: userRoles.MANAGER,
        SSP: userRoles.SSP,
        PUBLISHER: userRoles.PUBLISHER,
      },
    };
  },
});
